import {useAuthStore} from "~/store/auth"

export const useAppVersion = () => {
    const authStore = useAuthStore()

    const publicConfig = useRuntimeConfig()?.public

    const remoteVersion = computed(() => {
        return authStore.remoteVersion
    })

    const versionIsUpToDate = computed(() => {
        return remoteVersion.value && (publicConfig?.clientVersion === remoteVersion.value)
    })

    const versionMismatch = computed(() => {
        return remoteVersion.value && (publicConfig?.clientVersion !== remoteVersion.value)
    })

    return {
        versionIsUpToDate,
        versionMismatch
    }
}